<script lang="ts" setup>
import type { QPopupEditProps } from 'quasar'

const {
  anchor = 'bottom middle',
  self = 'top right',
} = defineProps<{
  anchor?: QPopupEditProps['anchor']
  self?: QPopupEditProps['self']
  offset?: [number, number]
}>()

const emit = defineEmits(['show', 'hide'])

function handleShow() {
  emit('show')
}

function handleHide() {
  emit('hide')
}
</script>

<template>
  <q-popup-edit
    :model-value="false"
    :anchor="anchor"
    :self="self"
    :offset="offset"
    :cover="false"
    class="app-popover"
    @before-show="handleShow"
    @before-hide="handleHide"
  >
    <slot />
  </q-popup-edit>
</template>
